import { useState, useCallback } from 'react';

/**
 * Track hover state for desktop interactions
 * Only active on desktop devices (with hover capability)
 */
export function useHoverFocus(): {
  hoveredIndex: number | null;
  handleMouseEnter: (index: number) => void;
  handleMouseLeave: () => void;
} {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const handleMouseEnter = useCallback((index: number) => {
    setHoveredIndex(index);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setHoveredIndex(null);
  }, []);

  return {
    hoveredIndex,
    handleMouseEnter,
    handleMouseLeave,
  };
}
